var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "bg-white", attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "v-row",
        { staticStyle: { "margin-top": "-10%" }, attrs: { justify: "center" } },
        [
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_smb_welcome } }),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "declined-lbl" }, [
              _vm._v("You’ve retracted this offer."),
            ]),
          ]),
          _c(
            "v-col",
            {
              staticClass: "ta-c mt-n4",
              attrs: { xl: "4", lg: "4", md: "5", sm: "10", cols: "10" },
            },
            [
              _c(
                "label",
                { staticClass: "submit-again" },
                [
                  _vm._v(
                    "We’ve let the carrier know that the opportunity has been canceled. This opportunity has been moved to "
                  ),
                  _c(
                    "v-chip",
                    {
                      staticClass: "in-progress-chip mx-1",
                      attrs: { color: "#EC6031", "text-color": "#f0f0f0" },
                    },
                    [_vm._v("Ready Bids")]
                  ),
                  _vm._v(
                    ". Please award a different carrier or place another bid."
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }